<script setup>
import { useCookies } from '@vueuse/integrations/useCookies';
import {computed, ref} from "vue";

// https://vueuse.org/integrations/useCookies/
const { set: setCookie, get: getCookie } = useCookies();

const cityConfirmed = ref(false);

const isConfirmed = computed(() => {
    return getCookie('cityConfirmed') ?? false;
});

checkCityConfirm();

function checkCityConfirm() {
    if (!isConfirmed.value) {
        setTimeout(() => {
            cityConfirmed.value = true;
        }, 2000);
    }
}

function onConfirm() {
    setCookie('cityConfirmed', true, {
        path: '/',
        expires: new Date(Date.now() + 2592000000),
    });
    cityConfirmed.value = false;
}
</script>

<template>
    <div
        v-if="cityConfirmed"
        id="notification-city"
        class="notification-cookie notification-cookie_city-confirm"
        :class="{ 'shown': cityConfirmed }"
    >
        <div class="notification-cookie__text">
            Ваш город {{ $root.selectedCity.NAME }}?
        </div>
        <div class="notification-cookie__btns">
            <button
                class="btn"
                data-notification-close
                @click="onConfirm()"
            >
                Да
            </button>
            <button
                class="btn btn--white"
                @click="onConfirm(); $root.$refs.citySelectorPopup.open()"
            >
                Выбрать другой
            </button>
        </div>
    </div>
</template>
